import type { IDocumentAttachmentsTable } from '@models/Forms/IForms';
import type { ISelectedFiles } from '@molecules/AttachFilesBlock/ISelectedFiles';

/**
 * Путь значения блока вложений в форме документа. Он ОДИН на все `attachmentsTable`
 * формы (см. AttachmentsTable.tsx → AttachFilesBlockControl name="files"), поэтому
 * два одновременно видимых блока затирают друг друга — конфигурация обязана разводить
 * их взаимоисключающими visibilityRules.
 */
export const ATTACHMENTS_FORM_PATH = 'files';

/** Подпись блока вложений по умолчанию (атрибут `name` формы её перекрывает). */
export const ATTACHMENTS_DEFAULT_LABEL = 'Документация';

/** Текст ошибки обязательности по умолчанию (атрибут `requiredMessage` её перекрывает). */
export const ATTACHMENTS_REQUIRED_MESSAGE = 'Приложите хотя бы один файл';

/**
 * Сколько файлов фактически приложено. Строки `_actType: 'delete'` — снятые пользователем
 * вложения, они уедут на сервер командой «удалить»; уже сохранённые (`_actType: 'edit'`)
 * и новые (`add`) считаются одинаково, поэтому в режиме редактирования проверка сама
 * учитывает существующие вложения документа.
 */
export const countEffectiveAttachments = (files: ISelectedFiles | undefined | null): number =>
    Array.isArray(files?.attachProperties)
        ? files.attachProperties.filter((property) => property?._actType !== 'delete').length
        : 0;

/**
 * Сколько вложений ждут отправки на сервер: всё, кроме уже сохранённых строк (`edit`).
 * Черновик бинарники не хранит, поэтому уход со страницы с такими строками — потеря файлов.
 */
export const countPendingAttachments = (files: ISelectedFiles | undefined | null): number =>
    Array.isArray(files?.attachProperties)
        ? files.attachProperties.filter((property) => property?._actType !== 'edit').length
        : 0;

/** Якорь блока вложений в DOM — цель перехода из панели «Заполнение» и от ошибки сохранения. */
export const getAttachmentsAnchorId = (table: Pick<IDocumentAttachmentsTable, 'id' | 'key'>): string =>
    `attachments:${table.id || table.key}`;

export const getAttachmentsRequiredMessage = (table: Pick<IDocumentAttachmentsTable, 'requiredMessage'>): string =>
    table.requiredMessage?.trim() || ATTACHMENTS_REQUIRED_MESSAGE;
